// extracted by mini-css-extract-plugin
export default {"container":"UIActionModal_container__uxMwR","imageContainer":"UIActionModal_imageContainer__Cxszm","image":"UIActionModal_image__CUXI+","button":"UIActionModal_button__uU0K2"};